import * as React from 'react';
import { echoService } from '@/services/echoService';
import type { VoiceCloneOptionsLanguage } from '@/types/echo_creation';

interface UseVoiceCloneOptionsReturn {
  languages: VoiceCloneOptionsLanguage[];
  accentsByLang: Record<string, string[]>;
  optionsLoading: boolean;
}

export function useVoiceCloneOptions(): UseVoiceCloneOptionsReturn {
  const [languages, setLanguages] = React.useState<VoiceCloneOptionsLanguage[]>([]);
  const [accentsByLang, setAccentsByLang] = React.useState<Record<string, string[]>>({});
  const [optionsLoading, setOptionsLoading] = React.useState(true);

  React.useEffect(() => {
    let cancelled = false;
    echoService
      .getVoiceCloneOptions()
      .then((data) => {
        if (cancelled) return;
        setLanguages(data.languages);
        setAccentsByLang(data.accents_by_language);
        setOptionsLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setOptionsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { languages, accentsByLang, optionsLoading };
}
